/* script */














































































import Vue from 'vue';
import Component from 'vue-class-component';
import Page from './Page';
import { components } from './app';

@Component({ props: ['page', 'show-notice'] })
class TabBarComponent extends Vue {
    menuUrl!: string;
    mypageUrl!: string;
    showNotice!: boolean;
    notice: boolean = false;
    page!: keyof typeof components;

    get app() {
        return (this.$parent as Page).app;
    }

    async created() {
        this.notice = this.showNotice;
    }

    _(label: string) {
        return (this.$parent as Page)._(label);
    }

    showCode() {
        if (this.app.code) this.app.setPage('Code');
        else this.notice = true;
    }

    closeNotice() {
        const id = this.app.reserve!.id;
        localStorage?.setItem('Mypage:ShownNotice:' + id, 'true');
        this.notice = false;
    }
}
const __vue_script__ = TabBarComponent;

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "tab-bar" } }, [
    _c("div", { staticClass: "bar" }, [
      _c("div", { staticClass: "buttons" }, [
        _c(
          "div",
          {
            class: _vm.page === "Terminal" ? "button is_active" : "button",
            on: {
              click: function ($event) {
                return _vm.app.setPage("Terminal")
              },
            },
          },
          [
            _c("span", { staticClass: "symbol fill" }, [_vm._v("home")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm._("home")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: _vm.page === "Code" ? "button is_active" : "button",
            on: {
              click: function ($event) {
                return _vm.showCode()
              },
            },
          },
          [
            _c("span", { staticClass: "icon" }, [_vm._v("qr_code")]),
            _vm._v(" "),
            _vm.app.checkedin
              ? _c("p", [_vm._v(_vm._s(_vm._("checkout")))])
              : _c("p", [_vm._v(_vm._s(_vm._("checkin")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: _vm.page === "House" ? "button is_active" : "button",
            on: {
              click: function ($event) {
                return _vm.app.openHouseInfo()
              },
            },
          },
          [
            _c("span", { staticClass: "icon" }, [_vm._v("domain")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm._("house_title")))]),
          ]
        ),
        _vm._v(" "),
        _vm.app.showMobileOrder()
          ? _c(
              "div",
              {
                class:
                  _vm.page === "MerchandiseCategories" ||
                  _vm.page === "MobileOrdered" ||
                  _vm.page === "MerchandiseList"
                    ? "button is_active"
                    : "button",
                on: {
                  click: function ($event) {
                    return _vm.app.setPage("MerchandiseCategories")
                  },
                },
              },
              [
                _c("span", { staticClass: "icon" }, [_vm._v("restaurant")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm._("order")))]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.app.showGratuity()
          ? _c(
              "div",
              {
                class:
                  _vm.page === "GratuityList" ? "button is_active" : "button",
                on: {
                  click: function ($event) {
                    return _vm.app.setPage("GratuityList")
                  },
                },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _vm._v("volunteer_activism"),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm._("gratuity")))]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            class: _vm.page === "Menu" ? "button is_active" : "button",
            on: {
              click: function ($event) {
                return _vm.app.setPage("Menu")
              },
            },
          },
          [
            _c("span", { staticClass: "symbol fill" }, [
              _vm._v("account_circle"),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm._("my_page")))]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.notice
      ? _c("div", { staticClass: "notice" }, [
          _c("div", { staticClass: "shadow" }),
          _vm._v(" "),
          _c("div", { staticClass: "checkin_modal dialog" }, [
            _c(
              "span",
              {
                staticClass: "control",
                on: {
                  click: function ($event) {
                    return _vm.closeNotice()
                  },
                },
              },
              [_vm._v("close")]
            ),
            _vm._v(" "),
            _c("div", [
              _c("h2", [_vm._v(_vm._s(_vm._("qr_notice_title")))]),
              _vm._v(" "),
              _c("img", {
                staticStyle: { filter: "brightness(0.5)" },
                attrs: { src: "/images/icon_QR.svg" },
              }),
              _vm._v(" "),
              _c("pre", [_vm._v(_vm._s(_vm._("qr_notice_description")))]),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeNotice()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm._("close")))]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "script_src/register/TabBar.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__